import React from "react";
import BaseInputValidator from "../../../common/input-validators/BaseInputValidator";
import Field from "../../../../model/configurator/Field";
import ExpandableContainer from "../../../configuration/steps/ExpandableContainer";
import BaseInputMethodCalculationComponentInterface from "./BaseInputMethodCalculationComponentInterface";
import TWSCalculationApiService from "../../../../api-services/TWSCalculationApiService";

interface SelfProps {
    renderField: (field: any, additionalProps?: object, validator?: BaseInputValidator | undefined) => any,
    fields: { [key: string]: Field },
    apiService: TWSCalculationApiService | null,
    availableTankVolumes: number[],
}

export class CapacityPInputMethod extends React.Component<SelfProps> implements BaseInputMethodCalculationComponentInterface {
    render() {
        return <React.Fragment>
            <div className={`row row-no-gutter`}>
                <div className="column-6 column-xs-12">
                    <div className={`card`}>
                        <div className={`card-body`}>
                            <ExpandableContainer arrowFirst={true} label={__('Calculate method')}
                                initialOpen={true}>
                                <div className={`step-inputs-row`}>
                                    {this.props.renderField(this.props.fields.capacityCapacity)}
                                    {this.canShowVolume() ? 
                                        this.props.renderField(this.props.fields.capacityVolume, {items: this.getTankVolumeItems()}) : <div/>
                                    }
                                    <div className={`grid-2 grid-gap-16 grid`}>
                                        {this.props.renderField(this.props.fields.capacityInstantaneous, { onlyYesOption: true })}
                                        {this.props.renderField(this.props.fields.capacitySemiInstantaneous, { onlyYesOption: true })}
                                    </div>
                                    <div />
                                    {this.props.renderField(this.props.fields.capacityPrimaryTank)}
                                </div>
                            </ExpandableContainer>
                        </div>
                    </div>
                </div>
                <div className={`column-6 column-xs-12`}>
                </div>
            </div>
        </React.Fragment>
    }

    getTankVolumeItems = () => {
        return this.props.availableTankVolumes.map(i => ({text: i, value: i}));
    }

    canShowVolume = (): boolean => {
        return this.props.fields.capacityPrimaryTank.value === true || this.props.fields.capacitySemiInstantaneous.value === true;
    }

    canProceed(): boolean {
        return this.props.fields.capacityCapacity.value && (!this.props.fields.capacitySemiInstantaneous.value || this.props.fields.capacityVolume.value > 0);
    }

    isValidFormModel(parameter: any): boolean {
        return this.canProceed();
    }
}